export default "__VITE_ASSET__BBrzLhoY__"